import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityDefaultShippingCostPayload } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useCreateDefaultShippingCost = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ProfitabilityDefaultShippingCostPayload) => adapter.createDefaultShippingCost(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['profitability', 'default-shipping-costs'] });
      qc.invalidateQueries({ queryKey: ['profitability', 'default-shipping-costs-missing'] });
    },
  });
};

export const useUpdateDefaultShippingCost = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ProfitabilityDefaultShippingCostPayload }) =>
      adapter.updateDefaultShippingCost(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['profitability', 'default-shipping-costs'] });
      qc.invalidateQueries({ queryKey: ['profitability', 'default-shipping-costs-missing'] });
    },
  });
};

export const useDeleteDefaultShippingCost = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => adapter.deleteDefaultShippingCost(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['profitability', 'default-shipping-costs'] });
      qc.invalidateQueries({ queryKey: ['profitability', 'default-shipping-costs-missing'] });
    },
  });
};
